import { Info } from '@mui/icons-material'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'
import { Box, Button, Tooltip } from '@mui/material'
import { fireQuoteSelected } from 'analytics/bookingEvents'
import InformationIcon from 'components/Bookings/TransportOptions/InformationIcon'
import DisplayPrice from 'components/Common/DisplayValues/DisplayPrice'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import useClient from 'hooks/useClient'
import useUserRole from 'hooks/useUserRole'

export default function AmendVehicleCard({
  selected = false,
  clientId,
  setAmendVehicleModal,
  setSelectedVehicle,
  vehicle,
  sx = {},
  quoteGroupId,
  groupQuotes,
}: any) {
  const { displayVATPrice } = useClient(clientId)
  const { validateAccess } = useUserRole()
  return (
    <Box
      component="div"
      sx={{
        borderRadius: '3px',
        color: '#0a2435',
        fontSize: '19px',
        fontWeight: 'bold',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxSizing: 'border-box',
        flex: '1 1 320px',
        minWidth: '100%',
        maxHeight: '240px',
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          gap: '15px',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#f7f7f7',
            borderRadius: '5px',
            maxWidth: '7.5rem',
            alignContent: 'center',
          }}
        >
          {vehicle.vehicleDetails?.icon && (
            <Box
              component="img"
              src={vehicle.vehicleDetails?.icon}
              sx={{
                alignSelf: 'center',
                objectFit: 'contain',
                maxWidth: '7.5rem',
              }}
            />
          )}
        </Box>
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-around',
            width: '50%',
            gap: '10px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
            }}
          >
            <Box
              component="p"
              sx={{
                alignSelf: 'flex-start',
                padding: '0',
                margin: '0',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                {VehicleDisplayName({
                  vehicleDetails: vehicle.vehicleDetails,
                })}
              </Box>
              {vehicle?.isDestinationLogicQuote && (
                <Tooltip title="Destination Supplier" arrow placement="top-end">
                  <Info
                    fontSize="medium"
                    sx={(theme) => ({
                      color: theme.palette.info.dark,
                      paddingLeft: '5px',
                      verticalAlign: 'bottom',
                    })}
                  />
                </Tooltip>
              )}
            </Box>

            {vehicle.vehicleDetails?.example && (
              <>
                <Box
                  component="p"
                  sx={{
                    fontWeight: 'light',
                    fontSize: '14px',
                    color: '#302f31',
                    alignSelf: 'flex-start',
                    margin: '0',
                  }}
                >
                  For example: {vehicle.vehicleDetails?.example}
                </Box>

                {validateAccess('Jyrney_Admin') && (
                  <Box
                    component="p"
                    sx={{
                      fontWeight: 'light',
                      fontSize: '14px',
                      color: '#302f31',
                      alignSelf: 'flex-start',
                      margin: '0',
                    }}
                  >
                    {vehicle.supplierName}
                  </Box>
                )}
              </>
            )}
          </Box>
          {vehicle.isPreferredSupplier && vehicle.supplierLogo ? (
            <Box sx={{ maxHeight: '20px', maxWidth: '50%' }}>
              <img
                src={vehicle.supplierLogo}
                alt={`Logo for ${vehicle.supplierName}`}
                height={'100%'}
              />
            </Box>
          ) : (
            <></>
          )}
          <Box sx={{ display: 'flex', gap: '10px' }}>
            <InformationIcon
              icon={<PeopleOutlineIcon />}
              text={vehicle.vehicleDetails?.seats}
            />

            <InformationIcon
              icon={<WorkOutlineIcon />}
              text={vehicle.vehicleDetails?.luggage}
            />
          </Box>
        </Box>

        <Box
          component="div"
          sx={{
            fontWeight: 'bold',
            fontSize: '28px',
            color: selected ? 'var(--jy-navy-900, #00253d)' : '#0a2435',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            component="p"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              height: 'auto',
            }}
          >
            {DisplayPrice({
              VATTotalPrice: vehicle?.estimatedTotal,
              displayVATPrice: displayVATPrice,
            })}
          </Box>
          <Button
            sx={{
              fontSize: '12px',
              backgroundColor: '#33759d',
              borderColor: '#b4b4b4',
            }}
            onClick={() => {
              fireQuoteSelected({
                surface: 'amend',
                quoteGroupId,
                selectedQuote: vehicle,
                groupQuotes,
              })
              if (typeof setSelectedVehicle === 'function') {
                setSelectedVehicle(vehicle)
              }
              if (typeof setAmendVehicleModal === 'function') {
                setAmendVehicleModal(true)
              }
            }}
          >
            Select
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
